// Make chevron clickable
(function() {
  function fixDropdowns() {
    const containers = document.querySelectorAll('.product-form__input-container');
    
    containers.forEach(function(container) {
      const chevron = container.querySelector('.svg-icon--chevron-down');
      const selectElement = container.querySelector('select');
      
      if (chevron && selectElement) {
        // Just make the chevron pass clicks through to select
        chevron.style.pointerEvents = 'none';
        
        // Ensure select is clickable everywhere
        selectElement.style.cursor = 'pointer';
        selectElement.style.width = '100%';
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDropdowns);
  } else {
    fixDropdowns();
  }
  
  setTimeout(fixDropdowns, 500);
})();
